import { colors } from '@mui/material';
import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },

  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  },
  columnContent1: {
    width: '6%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};
const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const DoctorWiseOpdProceduresReportPdf = ({ data }) => {
  console.log(data);
  const user = JSON.parse(localStorage.getItem('user'));

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Doctor Wise Opd And Procedures Report ">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '80px' }} content="Sr No" />
              <Text style={styles.columnHeader} content=" Bill Date" />
              <Text style={styles.columnHeader} content="Type" />
              <Text style={{ ...styles.columnHeader, width: '250px' }} content="Patient Name" />
              <Text style={styles.columnHeader} content="Uhid No." />
              <Text style={styles.columnHeader} content="Adm No" />
              <Text style={styles.columnHeader} content="Paymode" />
              <Text style={styles.columnHeader} content="Txn No" />
              <Text style={{ ...styles.columnHeader, width: '200px' }} content="Consultant" />
              <Text style={{ ...styles.columnHeader, width: '21%' }} content="Services" />
              <Text style={{ ...styles.columnHeader, width: '20%' }} content="Panel" />
              <Text style={styles.columnHeader} content="Bill Amt." />
              <Text style={styles.columnHeader} content="Dis Amt." />
              <Text style={styles.columnHeader} content="Recd Amt." />
              <Text style={styles.columnHeader} content="Bal. Amt." />
              <Text style={styles.columnHeader} content="Username" />
            </View>
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD " />
            </View>
            {data &&
              data?.opdData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width: '80px'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={styles.columnContent} content="OPD" />
                  <Text style={{ ...styles.columnContent, width: '250px', textAlign:'left' }}
                    content={`${data.name_suffix} ${data.first_name} ${data.last_name}`} />
                  <Text style={styles.columnContent} content={data.uhid} />
                  <Text style={styles.columnContent} content={data.adm_no_date} />
                  <Text style={styles.columnContent} content={data.payment_mode} />
                  <Text style={styles.columnContent} content={data.chq_card_no} />
                  <Text style={{ ...styles.columnContent, width: '200px' }} content={data.consultant.name} />
                  <Text style={{...styles.columnContent, width:'21%'}} content="" />
                  <Text style={styles.columnContent} content={data.sponsor.name} />
                  <Text style={{...styles.columnContent, textAlign:'right'}} content={data.reg} />
                  <Text style={{...styles.columnContent, textAlign:'right'}} content={data.disc} />
                  <Text style={{...styles.columnContent, textAlign:'right'}} content={data.recd} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.bal} />
                  <Text style={styles.columnContent} content={data.createdBy} />
                </View>
              ))}
            <View style={{ ...styles.row, marginLeft: '65%', width: '100%' }}>
              <Text style={{...styles.columnContent1, fontSize:'10px', color:'red', marginRight:'9px' }} content="TOTAL :" />
              <Text style={{...styles.columnContent1, width:'50px' }} content={data.opdData.stats.bill_amt} />
              <Text style={{...styles.columnContent1, width:'43px' }} content={data.opdData.stats.disc_amt} />
              <Text style={{...styles.columnContent1, width:'44px' }} content={data.opdData.stats.recd_amt} />
              <Text style={styles.columnContent1} content={data.opdData.stats.bal_amt} />
            </View>
            {/* OPD Billing Data Section */}
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD Procedures" />
            </View>
            {data &&
              data?.opdBillingData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={{...styles.columnContent, width: '80px'}} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={styles.columnContent} content="OPD Billing" />
                  <Text style={{ ...styles.columnContent, width: '250px', textAlign:'left' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                  <Text style={styles.columnContent} content={data.uhid} />
                  <Text style={styles.columnContent} content={data.patient.adm_no_date} />
                  <Text style={styles.columnContent} content={data.pay_mode} />
                  <Text style={styles.columnContent} content={data.cheque_no} />
                  <Text style={{ ...styles.columnContent, width: '200px' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '21%' }} content={data.combinedServiceDetails
                      .map(({ service_name, test_name }) => service_name || test_name)
                      .join(', ')} />
                  <Text style={styles.columnContent} content={data.patient.sponsor.name} />
                  <Text style={{...styles.columnContent, textAlign:'right'}} content={data.total_amt} />
                  <Text style={{...styles.columnContent, textAlign:'right'}} content={data.disc_amt} />
                  <Text style={{...styles.columnContent, textAlign:'right'}} content={data.total_recd} />
                  <Text style={{...styles.columnContent, textAlign:'right', marginRight:'10px'}} content={data.balance_amt} />
                  <Text style={styles.columnContent} content={data.createdBy} />
                </View>
              ))}
            {/* Add the billing stats for OPD data */}
            <View style={{ ...styles.row, marginLeft: '65%', width: '100%' }}>
              <Text style={{...styles.columnContent1, fontSize:'10px', color:'red', marginRight:'8px' }} content="TOTAL :" />
              <Text style={{...styles.columnContent1, width:'50px' }} content={data.opdBillingData.stats.bill_amt} />
              <Text style={{...styles.columnContent1, width:'43px' }} content={data.opdBillingData.stats.disc_amt} />
              <Text style={{...styles.columnContent1, width:'44px' }} content={data.opdBillingData.stats.recd_amt} />
              <Text style={styles.columnContent1} content={data.opdBillingData.stats.bal_amt} />
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default DoctorWiseOpdProceduresReportPdf;
